import { render, staticRenderFns } from "./XRDashboard.vue?vue&type=template&id=7713fcc8&scoped=true"
import script from "./XRDashboard.vue?vue&type=script&lang=js"
export * from "./XRDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7713fcc8",
  null
  
)

export default component.exports